module.exports = __webpack_public_path__ + "static/media/2.8fb47db1.jpg";